import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LyFocusState } from './focus-state.directive';
export * from './focus-state.directive';
var LyFocusStateModule = /** @class */ (function () {
    function LyFocusStateModule() {
    }
    LyFocusStateModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [LyFocusState],
                    exports: [LyFocusState]
                },] },
    ];
    /** @nocollapse */
    LyFocusStateModule.ctorParameters = function () { return []; };
    return LyFocusStateModule;
}());
export { LyFocusStateModule };
//# sourceMappingURL=focus-state.module.js.map